import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import GeneralInput from "../../common/GeneralInput";
import Modal from "../../common/Modal";
import AdminService from "../../../services/admin.service";
import { useAdmin } from "../../../context/admin";
import { Subzone } from "../../../types/common.types";
import { AiOutlineCloseCircle } from "react-icons/ai";
import Checkbox from "../../common/Checkbox";
import jsonToFormData from "../../../utils/jsonToFormData";
import FileInput from "../../common/FileInput";
import { useGlobal } from "../../../context/global";
import convertToWebP from "../../../utils/convertToWebP";

export default function EditSubzone() {
    const { editSubzoneId, setEditSubzoneId, subzonesZone } = useAdmin()
    const { setIsLoading, setMessage } = useGlobal()
    const [data, setData] = useState<Subzone>({} as Subzone)

    useEffect(() => {
        async function getInfo() {
            try {
                const list: Subzone[] = (await AdminService.listSubzones(subzonesZone)).data
                const sz = list.find(z => z.id === editSubzoneId)
                if (!sz) return
                setData({ ...sz, new_id: sz.id })
            } catch (error) {
                console.log(error);
            }
        }
        getInfo()
    }, [])

    async function submit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setIsLoading(true)
        try {
            let processedCover = data.cover;
            if (processedCover instanceof File) {
                try { processedCover = await convertToWebP(processedCover) }
                catch (err) { console.error('WebP error:', err) }
            }
            const newData: Partial<Subzone> = {
                id: data.id,
                new_id: data.new_id,
                zone_id: data.zone_id || subzonesZone,
                navbar: data.navbar,
                cover: processedCover,
                nombre: data.nombre,
                nombre_en: data.nombre_en,
                nombre_pt: data.nombre_pt,
                overview: data.overview,
                overview_es: data.overview_es,
                overview_pt: data.overview_pt,
                description: data.description,
                description_es: data.description_es,
                description_pt: data.description_pt,
                orden: data.orden,
            }
            const formData = jsonToFormData(newData)
            await AdminService.editSubzone(formData)
            window.location.reload()
        } catch (error: any) {
            console.log(error);
            setMessage({ type: 'error', content: error.response?.data || 'Error updating subzone' });
            setTimeout(() => setMessage(undefined), 2500);
        } finally {
            setIsLoading(false);
        }
    }

    function onChange(e: ChangeEvent<HTMLInputElement>) {
        const { name, value } = e.target
        setData(prev => ({ ...prev, [name]: value }))
    }

    const handleFileChange = async (newFile: File) => {
        try {
            setIsLoading(true);
            const webpFile = await convertToWebP(newFile);
            setData(prev => ({ ...prev, cover: webpFile }));
        } catch (error) {
            setData(prev => ({ ...prev, cover: newFile }));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal onSubmit={submit}>
            <h1>Edit subzone</h1>
            <p style={{ marginTop: 0, fontSize: 13, color: '#777' }}>Zona: <strong>{data.zone_id || subzonesZone}</strong></p>
            <div className="input-container">
                <Checkbox checked={data.navbar} label="Show in navbar"
                onChange={(checked: boolean) => setData(prev => ({ ...prev, navbar: checked }))} />
            </div>
            <div className="input-container">
                <GeneralInput name="new_id" label="New ID" value={data?.new_id || ''} onChange={onChange} />
            </div>
            <div className="input-container">
                <GeneralInput name="nombre" label="Nombre (es)" value={data.nombre || ''} onChange={onChange} />
                <GeneralInput name="nombre_en" label="Nombre (en)" value={data.nombre_en || ''} onChange={onChange} />
                <GeneralInput name="nombre_pt" label="Nombre (pt)" value={data.nombre_pt || ''} onChange={onChange} />
            </div>
            <div className="input-container">
                <FileInput value={data.cover} style={{ height: '100px' }}
                label="Cover (will be converted to WebP)" accept=".png, .jpg, .jpeg, .heic, .webp"
                onChange={handleFileChange}
                deleteFile={() => setData(prev => { const { cover, ...rest } = prev; return rest as Subzone; })} />
            </div>
            <div className="input-container">
                <GeneralInput name="overview" label="Overview (en)" value={data.overview || ''} onChange={onChange} />
                <GeneralInput name="overview_es" label="Overview (es)" value={data.overview_es || ''} onChange={onChange} />
                <GeneralInput name="overview_pt" label="Overview (pt)" value={data.overview_pt || ''} onChange={onChange} />
            </div>
            <div className="input-container">
                <GeneralInput name="description" label="Description (en)" value={data.description || ''} onChange={onChange} />
                <GeneralInput name="description_es" label="Description (es)" value={data.description_es || ''} onChange={onChange} />
                <GeneralInput name="description_pt" label="Description (pt)" value={data.description_pt || ''} onChange={onChange} />
            </div>
            <div className="input-container">
                <GeneralInput name="orden" label="Orden (0,1,2...)" value={(data.orden ?? 0).toString()} onChange={onChange} />
            </div>
            <div className="actions" style={{ marginTop: '20px' }}>
                <button type="submit">Submit</button>
            </div>
            <div className="close" title="close" onClick={() => setEditSubzoneId(undefined)}>
                <AiOutlineCloseCircle/>
            </div>
        </Modal>
    )
}
